import React, { Component } from "react";
import axios from "axios";
import '../../App.css';
import Top from "../top";
import SideBar from "../sidebar";
import PaginationEle from "../pagination";


export default class Codes extends Component {
    state = { list: [], id: 0, code: '', prize: '', codeStatus: 1, msg: '', error: '' , columns: [
                    
            {
                label: 'Action',
                field: 'action'
            },
            {
                label: 'Name',
                field: 'name'
            },
            {
                label: 'Status',
                field: 'stringStatus'
            }
        ]}
            constructor(props) {
                super(props);
               this.paginationEleRef = React.createRef()
            }
    componentDidMount() {
        this.getList()
        axios.get(localStorage.getItem('host') + '/settings/menus', {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        }).then(
            res => {
                this.setState({ menus: res.data });
            }, err => {
                console.log(".....")
            }
        )
    }
    codesAction(e) {
        var id = e.currentTarget.id;
        console.log("......." + id + " .... " + e.currentTarget.id)
        this.showForm(id);
    }
    showForm(id) {
        this.setState({id: 0, type: '', accountId: '', nextId: '', prize: '', accounts: [], codeStatus: 1, msg: ''}) 
            axios.get(localStorage.getItem('host') + '/settings/codesaction/' + id, {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }).then(
                res => {
                    this.setState({ id: res.data.id, code: res.data.code, prize: res.data.prize, codeStatus: res.data.codeStatus });
                }, err => {
                    console.log(".....")
                }
            )
        document.querySelector('#codesAction').style = 'display:block'
    }
    closePopup() {
        document.querySelector('#codesAction').style = 'display:none'
        console.log('......close');
    }
    savecodes() {
        var data = { id: this.state.id,  code: this.state.code, prize: this.state.prize, codeStatus: this.state.codeStatus }
        axios.post(localStorage.getItem('host') + '/settings/codesform', data, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        }).then(
            res => {
                console.log(res.data)
                this.setState({ msg: res.data });
                this.getList();
                this.closePopup();
                setTimeout(() => {
                    this.setState({ msg: '' });
                }, 3000);
            }, err => {
                console.log(".....")
            }
        )
    }
    getList() {
        axios.get(localStorage.getItem('host') + '/settings/codes/'+sessionStorage.getItem('companyId'), {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        }).then(
            res => {
                for (var index in res.data) {
                    res.data[index].action = <span className="link" title="Edit codes" id={res.data[index].id} onClick={e => this.codesAction(e)}><i className="bi bi-pencil-square"></i></span>
                }
                 this.paginationEleRef.current.update(res.data)
            }, err => {
                console.log(".....")
            }
        )
    }
    render() {
        let divMsg = ''
        if (this.state.msg) {
            divMsg = (<div className='alert alert-success'>{this.state.msg}</div>)
        }
        return (
            <div className="d-flex" id="wrapper">
            <SideBar />
            <div id="page-content-wrapper">
                <Top />

                <div className="container-fluid">
                <button className="btn btn-primary" onClick={() => this.showForm(0)} title="Add codes" ><i className="bi bi-plus-square"></i></button>
                        {divMsg}
                         <PaginationEle ref={this.paginationEleRef} titles={this.state.columns}  />
                        <div className="page-popup page-popup-overlay" id="codesAction">
                            <form  >
                                <div className="card card-green">
                                    <div className="card-header bg-info">
                                        Codes Action
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                            <div className="input-group"><span className="input-group-text">Name</span>
                                                <input type="text" className="form-control" value={this.state.code} onChange={e => { this.setState({ code: e.target.value }) }} /></div>
                                            </div>
                                            <div className="col">
                                            <div className="input-group"><span className="input-group-text">Status</span>
                                                <select className="form-control" value={this.state.codeStatus} onChange={e => { this.setState({ codeStatus: e.target.value }) }}  >
                                                    <option value="PENDING" >PENDING</option>
                                                    <option value="USED" >USED</option>
                                                </select></div>
                                            </div></div>
                                        
                                            <div className="row">
                                            <div className="col">
                                            <div className="input-group"><span className="input-group-text">Prize</span>
                                                <input type="text" className="form-control" value={this.state.prize} onChange={e => { this.setState({ prize: e.target.value }) }} /></div>
                                            </div>
                                            <div className="col"> </div>
                                            </div>     
                                        <div className="row">
                                            <div className="col" align="right"><input type="button" className="btn btn-primary" onClick={() => this.savecodes()} value="Save" /></div>
                                            <div className="col"><input type="button" className="btn btn-primary" onClick={() => this.closePopup()} value="Close" /></div>
                                        </div>
                                    </div></div>
                            </form>
                        </div>
                    </div>
                </div></div>
        )

    }
}    